import React from "react";
import {
  BaseSelectProps,
  FormControl,
  FormHelperText,
  InputLabel,
  Select as MuiSelect,
} from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";

interface SelectProps<T = string> extends BaseSelectProps<T> {
  helperText?: React.ReactNode;
  fullWidth?: boolean;
  size?: "small" | "medium";
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
  sx?: SxProps<Theme>;
}

function SelectWithRef<T = string>(props: SelectProps<T>, ref: React.ForwardedRef<HTMLSelectElement>) {
  const { label, children, error, helperText, disabled, required, slotProps, sx, fullWidth = true, size, ...rest } = props;

  return (
    <FormControl
      fullWidth={fullWidth}
      size={size}
      error={error}
      disabled={disabled}
      required={required}
      sx={{ marginY: "0.4rem", ...sx } as SxProps<Theme>}
    >
      {label && <InputLabel {...(slotProps as any)?.inputLabel}>{label}</InputLabel>}
      <MuiSelect ref={ref} label={label} {...rest} slotProps={slotProps}>
        {children}
      </MuiSelect>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

SelectWithRef.displayName = "Select";

const Select = React.forwardRef(SelectWithRef) as unknown as typeof SelectWithRef;

export default Select;
